export default __webpack_public_path__ + "static/media/agent_document_20221105112030.67cb5df4.pdf";